// client/src/components/shared/navigation/AppHeader.js
// Sticky topp-header med navigation och språkväxlare (sv/en via i18next).
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './AppHeader.css';

const AppHeader = ({ currentPage = 'home' }) => {
  const location = useLocation();
  const { t, i18n } = useTranslation();
  
  const currentLang = i18n.language;
  
  const navItems = [
    { path: '/', label: t('header.home'), icon: '🏠', key: 'home' },
    { path: '/smittlage', label: t('header.smittlage'), icon: '📊', key: 'smittlage' },
    { path: '/analytics', label: t('header.analytics'), icon: '📈', key: 'analytics' },
    { path: '/reports', label: t('header.reports'), icon: '⚡', key: 'reports' }
  ];

  const isActiveLink = (path) => {
    if (path === '/' && location.pathname === '/') return true;
    if (path !== '/' && location.pathname.startsWith(path)) return true;
    return false;
  };

  const toggleLanguage = () => {
    const newLang = currentLang === 'sv' ? 'en' : 'sv';
    i18n.changeLanguage(newLang);
  };

  return (
    <nav className="main-nav">
      <div className="nav-container">
        {/* Logo */}
        <div className="logo">
          EpiMeter
        </div>
        
        {/* Navigation Menu */}
        <ul className="nav-menu">
          {navItems.map((item) => (
            <li key={item.key} className="nav-item">
              <Link 
                to={item.path} 
                className={`nav-link ${isActiveLink(item.path) ? 'active' : ''}`}
              >
                <span>{item.icon}</span>
                {item.label}
              </Link>
            </li>
          ))}
        </ul>
        
        {/* Language Switcher */}
        <button 
          className="language-switcher"
          onClick={toggleLanguage}
          title={currentLang === 'sv' ? 'Switch to English' : 'Byt till svenska'}
        >
          <span className="lang-icon">🌐</span>
          <span className={`lang-option ${currentLang === 'sv' ? 'active' : ''}`}>SV</span>
          <span className="lang-divider">|</span>
          <span className={`lang-option ${currentLang === 'en' ? 'active' : ''}`}>EN</span>
        </button>
      </div>
    </nav>
  );
};

export default AppHeader;
